export enum BrowserLanguageCode {
    ENGLISH = 'en',
    HUNGARIAN = 'hu'
}
